import { Button, Card, Text } from "@shopify/polaris"
import { XIcon } from "@shopify/polaris-icons"
import { useTranslation } from "react-i18next"

import { LINK_BOOK_A_DEMO_OP } from "@/consts/link"
import { openLink } from "@/utils/redirectShopify"

interface BookADemo202506BannerProps {
  imageUrl: string
  onClose?: () => void
}

const BookADemo202506Banner = ({ imageUrl, onClose }:BookADemo202506BannerProps) => {
  const { t } = useTranslation("dashboard")

  const clickEmail = () => {
    // 获取GMT+8时区的当前时间
    const now = new Date()
    const gmt8Time = new Date(now.getTime() + (8 * 60 * 60 * 1000) + (now.getTimezoneOffset() * 60 * 1000))
    const hour = gmt8Time.getHours()

    // 根据时间选择邮箱
    // Harry: GMT8:00am-21:00pm (8:00-21:00)
    // Michael: GMT21:01pm-7:59am (21:01-23:59 和 0:00-7:59)
    const email = (hour >= 8 && hour <= 21) ? "harry@channelwill.io" : "michael.b@channelwill.io"

    window.open(`mailto:${email}?subject=Book%20a%20demo`)
  }

  return <Card padding={"400"}>
    <div className="
      flex
      flex-col
      md:flex-row
      md:justify-between
      items-start
      gap-6
    "
    >
      <div className="flex-1">
        <Text as="h2" variant="headingMd">
          {t("BookADemo202506Banner.title")}
        </Text>
        <div className="mt-2 max-w-[500px]">
          <Text as="p" variant="bodyMd">
            {t("BookADemo202506Banner.description")}
          </Text>
        </div>
        <div className="mt-3 flex gap-2">
          <Button
            variant={"primary"}
            onClick={() => openLink(LINK_BOOK_A_DEMO_OP)}
          >
            {t("BookADemo202506Banner.action")}
          </Button>
          <Button
            onClick={clickEmail}
          >
            {t("BookADemo202506Banner.emailAction")}
          </Button>
        </div>
      </div>
      <div className="
        flex
        md:justify-center
        md:justify-end
        w-full
        md:w-auto
      "
      >
        <img
          src={imageUrl}
          alt="Book a demo"
          className="w-[12.5rem] h-auto object-contain"
        />
      </div>
      <div className="flex-shrink-0 absolute right-4 md:static">
        <Button variant="tertiary" icon={XIcon} onClick={onClose} />
      </div>
    </div>
  </Card>
}

export default BookADemo202506Banner
